import { FC, PropsWithChildren } from 'react';

import { LocalizationAndDate } from '../injections/LocalizationAndDate';
import { QueryClient } from '../injections/QueryClient';
import { Store } from '../injections/Store';
import { Theme } from '../injections/Theme';

/**
 * Композиция приложения
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
export const MainComposition: FC<PropsWithChildren> = ({ children }) => {
  return (
    <QueryClient>
      <Store>
        <LocalizationAndDate>
          <Theme>{children}</Theme>
        </LocalizationAndDate>
      </Store>
    </QueryClient>
  );
};
